import { _ as t } from "../internals/export.js";
var a = Math.floor,
  r = Math.log,
  o = Math.LOG2E;
t({
  target: "Math",
  stat: !0
}, {
  clz32: function clz32(t) {
    var n = t >>> 0;
    return n ? 31 - a(r(n + .5) * o) : 32;
  }
});